import React from "react";
import { useNavigate } from "react-router-dom";
/** Components Import */
import EmptyBox from "../../Components/EmptyBox";
import Card from "../../Components/Card_wrap";
import BasicArea from "../../Components/PDA/BarcodeArea";
import BasicInput from "../../Components/Input_Basic";
import BasicCombo from "../../Components/Combo_Basic";
import CardH3 from "../../Components/Card_H3";
import Snackbar from "../../Components/Snackbar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCircleArrowRight as RightArrows,
  faClipboardCheck as OrderComplete,
  faHourglassHalf as StandBy,
  faBoxOpen as Producted,
  faBox as Packing,
  faTruckArrowRight as Delivery,
} from "@fortawesome/free-solid-svg-icons";
import BasicButton from "../../Components/Button_Basic";

function MM10070(props) {
  React.useEffect(() => {
    if (document.title === "생산실적관리") {
      return;
    } else {
      document.title = "생산실적관리";
      const element = document.getElementById("topbar");
      element.innerHTML =
        "<h1>" +
        "<span class='bullet'>" +
        "</span>" +
        "<strong class='depth-1'>" +
        "생산관리" +
        "	</strong>" +
        "<span class='divider' >" +
        "</span>" +
        "<strong'>공정현황(PDA)</strong>" +
        "</h1>";
    }
  }, []);
  React.useEffect(() => {
    const HandleEnterKey = (e) => {
      const { key, keyCode } = e;
      if (keyCode === 13) {
        navigator.clipboard.readText().then((clipboardText) => {
          if (
            clipboardText.substring(4, 6) === "WO" &&
            clipboardText.length === 10
          ) {
            props.WoNoSearch(clipboardText);
          } else {
            setSnackbars({
              toggle: true,
              type: "error",
              message: "Barcode번호를 확인해주세요",
            });
          }
        });
      }
    };
    window.addEventListener("keypress", HandleEnterKey);

    return () => window.removeEventListener("keypress", HandleEnterKey);
  });
  const [snackbars, setSnackbars] = React.useState({
    toggle: false,
    type: "",
    message: "",
  });

  return (
    <div>
      <EmptyBox />
      <BasicArea
        inputValue={props.inputs.barcodeValue}
        onInputChange={(e) => {
          props.setInputs({
            ...props.inputs,
            barcodeValue: e,
          });
        }}
        switchValue={props.inputs.switchValue}
        onSwitchChange={(e) => {
          props.setInputs({
            ...props.inputs,
            switchValue: e,
          });
        }}
        onInputKeyDown={(e) => {
          props.setBomDataList([
            {
              value: "",
              name: "",
            },
          ]);
          props.setProcDataList([
            {
              value: "",
              name: "",
            },
          ]);
        }}
        onInputKeyUp={(e) => {
          if (props.inputs.barcodeValue.length === 10) {
            props.WoNoSearch();
          } else {
            setSnackbars({
              toggle: true,
              type: "error",
              message: "Barcode번호를 확인해주세요",
            });
          }
        }}
        autoFocus={true}
      />
      <Card
        wrapStyle={{
          height: "64vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "start",
          alignItems: "flex-start",
        }}
      >
        <ul className="tab_nav" style={{ marginTop: "5px" }}>
          <li>
            <a
              className={props.tabToggle ? "" : "active"}
              onClick={() => props.setTabToggle(false)}
            >
              {props.lanData.length > 0
                ? props.lanData.filter(
                    (f) =>
                      f.lanId === "Fom_WorkInInformation" &&
                      f.lanType === "FORM"
                  )[0].lanName
                : ""}
            </a>
          </li>
          <li>
            <a
              className={!props.tabToggle ? "" : "active"}
              onClick={() => props.setTabToggle(true)}
            >
              {props.lanData.length > 0
                ? props.lanData.filter(
                    (f) =>
                      f.lanId === "Fom_MaterialInInformation" &&
                      f.lanType === "FORM"
                  )[0].lanName
                : ""}
            </a>
          </li>
        </ul>
        <CardH3 name="작업정보" />
        <BasicCombo
          style={{ marginRight: "38px" }}
          containerStyle={{ flexWrap: "noWrap" }}
          name="자재품명"
          combos={props.bomDataList}
          value={props.bomData}
          onChange={(e) => {
            if (e.length > 0) {
              props.SearchBomData(
                e,
                props.inputs.soNo,
                props.inputs.woNo,
                props.inputs.itemCd
              );
            }
            props.setBomData(e);
            // props.setInputs({
            //   ...props.inputs,
            //   bomOrderQty: e.target.value,
            // });
          }}
          // disabled={true}
        />

        <BasicInput
          containerStyle={{ flexWrap: "noWrap", width: "300px" }}
          name="투입수량"
          value={props.inputs.bomOrderQty}
          onChange={(e) => {
            props.setInputs({
              ...props.inputs,
              bomOrderQty: e.target.value,
            });
          }}
          disabled={true}
        />
        <CardH3 name="공정정보" />
        <BasicInput
          containerStyle={{ flexWrap: "noWrap", width: "300px" }}
          name="최근공정"
          value={props.inputs.processNm}
          onChange={(e) => {
            props.setInputs({
              ...props.inputs,
              processNm: e.target.value,
            });
          }}
          disabled={true}
        />
        <BasicCombo
          style={{ marginRight: "63px" }}
          containerStyle={{ flexWrap: "noWrap" }}
          name="설비"
          combos={props.procDataList}
          value={props.procData}
          onChange={(e) => {
            if (e.length > 0) {
              props.SearchProcData(e, props.inputs.woNo);
            }
            props.setProcData(e);
          }}
          // disabled={true}
        />
        <BasicInput
          containerStyle={{ flexWrap: "noWrap", width: "300px" }}
          name="시작시간"
          value={props.inputs.wkStDt}
          onChange={(e) => {
            props.setInputs({
              ...props.inputs,
              wkStDt: e.target.value,
            });
          }}
          disabled={true}
        />
        <BasicInput
          containerStyle={{ flexWrap: "noWrap", width: "300px" }}
          name="종료시간"
          value={props.inputs.wkEdDt}
          onChange={(e) => {
            props.setInputs({
              ...props.inputs,
              wkEdDt: e.target.value,
            });
          }}
          disabled={true}
        />
      </Card>
      {/* <Card
        wrapStyle={{
          minHeight: "30vh",
        }}
      > */}
      {/* <CardH3 name="생산정보" /> */}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "flex-start",
        }}
      >
        <BasicButton
          style={{ padding: "10px 15px" }}
          name="생산실적관리"
          onClick={() => props.ProcMove()}
        />
      </div>
      {/* </Card> */}
      {snackbars.toggle && (
        <Snackbar snackbars={snackbars} setSnackbars={setSnackbars} />
      )}
    </div>
  );
}

export default MM10070;
